import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useAppLoaders } from '@ori-appshell/app-loaders';
import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import { useEnvironment } from '@ori/environment';
import { useFeatureToggles } from '@ori/feature-toggles';
import { useLanguage } from '@ori/i18n';
import { useHideNextJsErrorOverlay } from '@ori/presentation-hooks';
import { useAnalyticsSignalEventListener } from '@ori/presentation-http';
import { useEffect, useMemo } from 'react';
import { PageFeatures } from '../common-data/PageFeatures';
export const LayoutContentLoader = (param)=>{
    let { useOpenedMinibagOnDesktop = false, children } = param;
    const { setAppLoaders } = useAppLoaders();
    const { globalApiUrl } = useServiceUrls([
        'globalApi'
    ]);
    const { features } = useFeatureToggles();
    const { tenant } = useEnvironment();
    const { language } = useLanguage();
    const { isAnonymousUser, isUserVerified, token, customerId } = useToken();
    useHideNextJsErrorOverlay();
    useAnalyticsSignalEventListener({
        language,
        token,
        tenant,
        globalApiUrl,
        customerId,
        enabled: features.includes(PageFeatures.SendSearchEvents)
    });
    const appLoadersForLoggedInEnabled = isUserVerified && !isAnonymousUser;
    const libs = useMemo(()=>({
            backInStockNotification: {
                enabled: true
            },
            basketBubble: {
                enabled: true
            },
            basketProvider: {
                enabled: true
            },
            feedbackBenefitDialog: {
                enabled: true
            },
            loyaltyDialog: {
                enabled: appLoadersForLoggedInEnabled
            },
            miniShoppingBag: {
                enabled: true,
                useOpenedMinibagOnDesktop
            },
            novageSkincareAdvisor: {
                enabled: true
            },
            productInfoDialog: {
                enabled: true
            },
            subscriptionWizard: {
                enabled: true
            }
        }), [
        appLoadersForLoggedInEnabled,
        useOpenedMinibagOnDesktop
    ]);
    const spas = useMemo(()=>({
            logoutConfirmDialog: {
                enabled: appLoadersForLoggedInEnabled
            },
            userSessionProvider: {
                enabled: appLoadersForLoggedInEnabled
            }
        }), [
        appLoadersForLoggedInEnabled
    ]);
    // Client one
    useEffect(()=>{
        setAppLoaders({
            libs,
            spas
        });
    }, [
        setAppLoaders,
        spas,
        libs
    ]);
    // eslint-disable-next-line react/jsx-no-useless-fragment -- TODO -- fix this
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
